import type { DmmServiceReturnType } from "~/components/blocks/layout/global-navi/type";

export const convertServiceMenuOriginalTo = (data: DmmServiceReturnType) => {
  const items = data.items.map(({ name, src, href, data_link, floors: originalFloors, new: isNew }) => {
    const floors = originalFloors.map(({ name, href, data_link, src, new: isNew }) => ({
      name,
      href,
      data_link,
      src,
      isNew,
    }));

    return {
      name,
      src,
      href,
      data_link,
      floors,
      isNew,
    };
  });
  return items;
};
